module.exports = __webpack_public_path__ + "static/media/bulkUsersRegistrationNomination.a5f7cbc0.xls";